import { render } from "./BuyingGroupAdmin.vue?vue&type=template&id=50f69f64"
import script from "./BuyingGroupAdmin.vue?vue&type=script&lang=js"
export * from "./BuyingGroupAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__